import { api } from "@/lib/api";

let cached = null;
export const loadWaTemplate = async (force = false) => {
  if (!cached || force) cached = (await api.get("/settings/whatsapp")).data;
  return cached;
};
export const setWaCache = (data) => { cached = data; };

export const normalizePhone = (raw) => {
  const s = String(raw || "").trim();
  let d = s.replace(/\D/g, "");
  if (!d) return "";
  if (s.startsWith("+")) return d;
  if (d.startsWith("00")) return d.slice(2);
  if (d.startsWith("39") && d.length >= 11) return d;
  return `39${d}`;
};

export const fillTemplate = (tpl, a) => {
  const [date, time] = a.start.split("T");
  const dt = new Date(`${date}T00:00`);
  const data = dt.toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" });
  const map = {
    nome: a.client_first_name || (a.client_name || "").split(" ")[0] || "",
    data, ora: time, trattamento: a.treatment_name || "il tuo trattamento", operatore: a.operator_name || "",
  };
  return tpl.replace(/\{(nome|data|ora|trattamento|operatore)\}/g, (_, k) => map[k]);
};

export const waLink = (phone, text) => `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
